import { graphql, useFragment } from 'react-relay';

import { type useShowVimeoVideo_item$key } from './__generated__/useShowVimeoVideo_item.graphql.ts';

const itemFragment = graphql`
    fragment useShowVimeoVideo_item on Item {
        videoVimeo(convertToVimeoFormat: false) {
            status
            vimeoId
        }
        videoMux {
            status
            playbackId
        }
    }
`;

export const useShowVimeoVideo = ({
    item: itemRef,
}: {
    item: useShowVimeoVideo_item$key;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);

    const videoVimeo = item?.videoVimeo;
    const videoMux = item?.videoMux;

    const showMuxVideo = videoMux?.status === 'ready' && !!videoMux?.playbackId;
    const showVimeoVideo = !!videoVimeo?.vimeoId && videoVimeo?.status === 'available';
    const showVideo = showVimeoVideo || showMuxVideo;

    return !!showVideo;
};
